export default function getEllipsedText(text = '', nrOfCharactersToReturn = 15) {
  const chars = text.split('');
  const slicedText = chars.length < nrOfCharactersToReturn ? text : chars.slice(0, nrOfCharactersToReturn).join('');
  return `${slicedText}...`;
}
